import { render, staticRenderFns } from "./FormTwo.vue?vue&type=template&id=7cb98b34&scoped=true&"
import script from "./FormTwo.vue?vue&type=script&lang=js&"
export * from "./FormTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb98b34",
  null
  
)

export default component.exports